import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);

// Helper function to format date ranges
export const formatDateRange = (start, end) => {
  const startStr = start ? start.toLocaleString() : "";
  const endStr = end ? end.toLocaleString() : "";
  return `${startStr} to ${endStr}`;
};

export const formatSingleDate = (date) => {
  if (!date) return "";
  if (date instanceof Date) return date.toLocaleDateString();
  if (date.$isDayjsObject) return date.format("YYYY-MM-DD");
  return String(date);
};

/**
 * Formats a date string into "ddd, MMM Do YYYY, hh:mm:ss A"
 * Example: "2025-05-08 21:24:55" => "Thu, May 8th 2025, 09:24:55 PM"
 *
 * @param input - The date string in "YYYY-MM-DD HH:mm:ss" format
 * @returns The formatted date string
 */
export function formatDateWithOrdinal(input) {
  return dayjs(input, "YYYY-MM-DD HH:mm:ss").format(
    "ddd, MMM Do YYYY, hh:mm:ss A"
  );
}

export const formatDate = (date) => {
  return date ? dayjs(date).format("DD/MM/YYYY") : "";
};
